"use strict";

exports.__esModule = true;
exports.doesInstantaneousEventListExist = exports.allowTooltipAxisToBeActive = exports.INSTANTANEOUS_EVENT_HEIGHT = exports.AXIS_HEIGHT = void 0;
exports.findEventsFallingInPixel = findEventsFallingInPixel;
exports.findIntervalBetweenEvents = findIntervalBetweenEvents;
exports.getStripeChartHeight = exports.getFormattedUserName = void 0;
exports.toleranceFromWidth = toleranceFromWidth;
exports.uniqueConditions = uniqueConditions;
var _Utils = require("../../../Utils");
var _constants = require("../../Logbook/constants");
var _helpers = require("../../InstantaneousEvent/helpers");
var _timeDefinitions = require("../../timeDefinitions");
var AXIS_HEIGHT = exports.AXIS_HEIGHT = 20;
var INSTANTANEOUS_EVENT_HEIGHT = exports.INSTANTANEOUS_EVENT_HEIGHT = 16;
var getStripeChartHeight = exports.getStripeChartHeight = function getStripeChartHeight(height, axis, instantaneousEventList) {
  if (axis === void 0) {
    axis = true;
  }
  if (instantaneousEventList === void 0) {
    instantaneousEventList = [];
  }
  var stripeChartHeight = axis ? height - AXIS_HEIGHT : height;
  return doesInstantaneousEventListExist(instantaneousEventList) ? stripeChartHeight - INSTANTANEOUS_EVENT_HEIGHT : stripeChartHeight;
};
var allowTooltipAxisToBeActive = exports.allowTooltipAxisToBeActive = function allowTooltipAxisToBeActive(y, events) {
  if (events === void 0) {
    events = [];
  }
  var finalY = doesInstantaneousEventListExist(events) ? y - (INSTANTANEOUS_EVENT_HEIGHT + 9) : y;
  return finalY >= 0;
};
var doesInstantaneousEventListExist = exports.doesInstantaneousEventListExist = function doesInstantaneousEventListExist(instantaneousEventList) {
  if (instantaneousEventList === void 0) {
    instantaneousEventList = [];
  }
  return Array.isArray(instantaneousEventList) && instantaneousEventList.length !== 0;
};
var getFormattedUserName = exports.getFormattedUserName = function getFormattedUserName(creator, users, eventType) {
  if (eventType === _helpers.InstantaneousEventAlerts) {
    return null;
  } else if (!creator) {
    return _constants.INTERNAL_USER;
  } else {
    var user;
    if (eventType === _helpers.InstantaneousEventComments) {
      user = users ? users.getUserByName(creator) : null;
    } else if (eventType === _helpers.InstantaneousEventTickets) {
      user = users ? users.getUser(creator) : null;
    }
    return user ? (0, _Utils.formatUserName)(user) : _constants.INTERNAL_USER;
  }
};
function findEventsFallingInPixel(timeline, time, millisPerPixel) {
  var eventsWithDeltas = timeline.map(function (event) {
    return {
      event: event,
      fallsInto: event.interval.startMillis >= time - millisPerPixel && event.interval.startMillis <= time + millisPerPixel
    };
  });
  var result = eventsWithDeltas.reduce(function (array, currentEvent) {
    return currentEvent.fallsInto ? array.concat([currentEvent.event]) : array;
  }, []);
  return result.length ? result : null;
}
function toleranceFromWidth(width, windowWidth, interval) {
  if (width === 0) {
    return 0;
  }
  var pixelPerMilli = width / (interval.endMillis - interval.startMillis);
  if (pixelPerMilli <= 0) {
    return 0;
  }
  return Math.ceil(windowWidth / pixelPerMilli);
}
function uniqueConditions(data) {
  if (data[0].type !== "condition") return data;
  return data.reduce(function (counted, condition) {
    var index = counted.findIndex(function (v) {
      var _condition$entity, _v$entity, _condition$dimensions, _v$dimensions, _condition$dimensions2, _v$dimensions2;
      return ((_condition$entity = condition.entity) == null ? void 0 : _condition$entity.native_code) === ((_v$entity = v.entity) == null ? void 0 : _v$entity.native_code) && ((_condition$dimensions = condition.dimensions) == null ? void 0 : _condition$dimensions.condition_text) === ((_v$dimensions = v.dimensions) == null ? void 0 : _v$dimensions.condition_text) && ((_condition$dimensions2 = condition.dimensions) == null ? void 0 : _condition$dimensions2.condition_level) === ((_v$dimensions2 = v.dimensions) == null ? void 0 : _v$dimensions2.condition_level);
    });
    if (index === -1) {
      counted.push(condition);
    }
    return counted;
  }, []);
}
function findIntervalBetweenEvents(timelineStart, timelineEnd) {
  var timelineLengthInMillis = timelineEnd - timelineStart;
  if (timelineLengthInMillis < _timeDefinitions.MINUTE_IN_MILLIS) {
    return {
      timestamp: 1000,
      timeFormat: "YYYY-MM-DD HH:mm:ss"
    };
  } else if (timelineLengthInMillis >= _timeDefinitions.MINUTE_IN_MILLIS && timelineLengthInMillis < (0, _timeDefinitions.getHoursMillis)(2)) {
    return {
      timestamp: _timeDefinitions.MINUTE_IN_MILLIS,
      timeFormat: "YYYY-MM-DD HH:mm"
    };
  } else if (timelineLengthInMillis >= (0, _timeDefinitions.getHoursMillis)(2) && timelineLengthInMillis < _timeDefinitions.DAY_IN_MILLIS) {
    return {
      timestamp: (0, _timeDefinitions.getMinutesMillis)(30),
      timeFormat: "YYYY-MM-DD HH:mm"
    };
  } else if (timelineLengthInMillis >= _timeDefinitions.DAY_IN_MILLIS && timelineLengthInMillis < _timeDefinitions.WEEK_IN_MILLIS) {
    return {
      timestamp: _timeDefinitions.HOUR_IN_MILLIS,
      timeFormat: "YYYY-MM-DD HH"
    };
  } else if (timelineLengthInMillis >= _timeDefinitions.WEEK_IN_MILLIS && timelineLengthInMillis < (0, _timeDefinitions.getDaysMillis)(30)) {
    return {
      timestamp: _timeDefinitions.DAY_IN_MILLIS,
      timeFormat: "YYYY-MM-DD"
    };
  } else {
    return {
      timestamp: 0,
      timeFormat: "YYYY-MM-DD"
    };
  }
}